<template>
	<div class="ReReassignExtCalls">
		<!-- <h4 class="m-0">{{placeholder}}</h4> -->
		<base-button type="primary" simple class="tmplt-btn" @click="signUpStaff()">Подписать сотрудника на телефонии</base-button>
	</div>
</template>

<script>
	// import { BaseCheckbox } from 'src/components/index';
	export default {
		name: 'ReReassignExtCalls',
		components: {
			// BaseCheckbox,
		},
		props: {
			value: Object,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			placeholder: String,
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {
			signUpStaff(){
				// console.log('signUpStaff and some shit ' );
			},

		},
	}
</script>
<style scoped>
	.ReReassignExtCalls{display: flex; align-items: baseline; justify-content: space-between;}
	.ReReassignExtCalls > * {display: inline-block;}
</style>
